import { DynamoDbList } from "../DynamoDbList";
import { emptyV2Api as api } from "../emptyV2Api";
import { DataMappingJob } from "./DataMappingJob";

const SLUG = "/data-mapping"

const injectedApi = api
  .enhanceEndpoints({ addTagTypes: ["dataMapping", "forms", "dataMappingJobs"] })
  .injectEndpoints({
    endpoints: (build) => ({
      getForms: build.query<FormGet[], void>({
        query: () => SLUG + "/forms",
        providesTags: ["forms"]
      }),
      getVendors: build.query<string[], void>({
        query: () => SLUG + `/vendors`,
        providesTags: ["dataMapping"],
      }),
      // getDataMappings: build.query<DataMappingGet, DataMappingGetRequest>({
      //   query: (req) => SLUG + `/manage?vendorId=${req.vendorId}`
      //                          + `${req.after ? `&after=${req.after}` : ""}`
      //                          + `${req.search && req.search.length > 0
      //                             ? `&search=${req.search}`
      //                             : ""}`,
      //   providesTags: ["dataMapping"],
      // }),
      getDataMappingJobs: build.query<DynamoDbList<DataMappingJob>, void>({
        query: () => SLUG + "/upload",
        providesTags: ["dataMappingJobs"]
      }),
      getDataMappings: build.query<DataMappingGet, DataMappingGetRequest>({
        query: (req) => ({
          url: SLUG + "/get",
          method: "POST",
          body: req
        }),
        providesTags: ["dataMapping"]
      }),
      postDataMapping: build.mutation<void, DataMappingUpload>({
        query: (dataMapping) => ({
          url: SLUG + "/manage",
          method: "POST",
          body: dataMapping,
        }),
        invalidatesTags: ["dataMapping"],
      }),
      putDataMapping: build.mutation<void, DataMappingPut>({
        query: ({ id, dataMapping }) => ({
          url: SLUG + `/manage?id=${id}`,
          method: "PUT",
          body: dataMapping,
        }),
        invalidatesTags: ["dataMapping"],
      }),
      deleteDataMapping: build.mutation<void, string>({
        query: (id) => ({
          url: SLUG + `/manage?id=${id}`,
          method: "DELETE",
        }),
        invalidatesTags: ["dataMapping"],
      }),
    })
});

/**
 * Types
 * TODO: Migrate to autogenerated API slices
 */
export type DataMapping = {
  Id: string;
  InternalSku: string;
  IsDeprecated?: boolean;  // removes from manual selection, does not affect routing atm
  FormId: string;
  Type: string;
  VendorId: string;
  VendorSku: string;
  Countries?: string[];
  ItemDetails: {
    Title?: string;
    ImageUrl?: string;
    Price?: string;
    Enabled?: boolean;
    Type?: "local" | "simply";
    Gbs?: number;
    Days?: number;
    IsSimplyForYou?: boolean;
  }
  RedemptionDetails?: {
    ImageUrl?: string;
    Description?: string;
    ApnSetting?: string;
    IsLpaUpload?: string | boolean;
  },
  CreatedAt: string;
  UpdatedAt: string;
  DistributorCode?: string;
  TakeappVariantId?: string;
}

export type DataMappingGetRequest = {
  vendorId: string,
  after?: string | null
  search?: string
}

export type DataMappingGet = {
  Items: DataMapping[],
  Count: number,
  LastEvaluatedKey?: {
    Id: string,
    VendorId: string
  }
}

export type FormGet = {
  Id: string;
  RedemptionFields: FormRedemptionField[];
}

export type FormRedemptionField = {
  label: string;
  maxLength: number;
  name: string;
  prefilledValue: string | null;
  required: boolean;
  type: string;
}



export type DataMappingUpload = Omit<DataMapping,
                                     "Id" | "CreatedAt" | "UpdatedAt">

export interface DataMappingPut {
  id: string;
  dataMapping: DataMappingUpload;
}

export { injectedApi as dataMappingApi };

export const {
  useGetFormsQuery,
  useGetVendorsQuery,
  useGetDataMappingJobsQuery,
  useGetDataMappingsQuery,
  useLazyGetDataMappingsQuery,
  usePostDataMappingMutation,
  usePutDataMappingMutation,
  useDeleteDataMappingMutation,
} = injectedApi;
